import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import styles from "./item-total-quantity.module.css";

interface ItemTotalInGroupsProps {
  totalPieces: number;
}

export const ItemTotalQuantity = ({ totalPieces }: ItemTotalInGroupsProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles["item-total-quantity"]}>
      <FixaText
        className={styles["item-total-label"] || ""}
        textStyle={"HeadingRegular.XS"}
      >{`${t("totalString")}:`}</FixaText>
      <FixaText textStyle={"Heading.XS"}>
        {t("piecesCountString", { count: totalPieces })}
      </FixaText>
    </div>
  );
};
